export default "__VITE_ASSET__Bw$EUip4__ 640w, __VITE_ASSET__Cgghxe70__ 971w";